import { useContext, useEffect } from 'react';
import { RouteSEOContext } from '../contexts/RouteSEOContext';

const useSEO = ({ title, description, keywords, canonical }) => {
  const routeManagesSEO = useContext(RouteSEOContext);
  const canonicalUrl = !routeManagesSEO && canonical
    ? new URL(canonical, 'https://www.seawhatyousave.com').href
    : undefined;

  useEffect(() => {
    // Set document title
    if (title) {
      document.title = title;
    }

    // Set description meta tag
    if (description) {
      let descriptionTag = document.querySelector('meta[name="description"]');
      if (descriptionTag) {
        descriptionTag.setAttribute('content', description);
      } else {
        descriptionTag = document.createElement('meta');
        descriptionTag.setAttribute('name', 'description');
        descriptionTag.setAttribute('content', description);
        document.head.appendChild(descriptionTag);
      }
    }

    // Set keywords meta tag
    if (keywords) {
      let keywordsTag = document.querySelector('meta[name="keywords"]');
      if (keywordsTag) {
        keywordsTag.setAttribute('content', keywords);
      } else {
        keywordsTag = document.createElement('meta');
        keywordsTag.setAttribute('name', 'keywords');
        keywordsTag.setAttribute('content', keywords);
        document.head.appendChild(keywordsTag);
      }
    }

    // Set canonical URL
    if (canonicalUrl) {
      let canonicalTag = document.querySelector('link[rel="canonical"]');
      if (canonicalTag) {
        canonicalTag.setAttribute('href', canonicalUrl);
      } else {
        canonicalTag = document.createElement('link');
        canonicalTag.setAttribute('rel', 'canonical');
        canonicalTag.setAttribute('href', canonicalUrl);
        document.head.appendChild(canonicalTag);
      }
    }

    // Cleanup function to reset title on unmount
    return () => {
      if (title && !routeManagesSEO) {
        document.title = 'Sea What You Save';
      }
    };
  }, [title, description, keywords, canonicalUrl, routeManagesSEO]);
};

export default useSEO;
